import axiosInstance from '../../../helpers/backend_helper';


const createEpisode = async (bookId, title, storyText, duration, coverImage, audioLink, videoLinkString) => {
  try {
    const formData = new FormData();
    formData.append('name', title);
    formData.append('content', storyText);
    formData.append('image', coverImage);
    audioLink && formData.append('audio', audioLink);
    videoLinkString && formData.append('video', videoLinkString);
    formData.append("duration", duration);
    formData.append("story_id", bookId);

    const response = await axiosInstance.post(`episodes`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error creating episode:', error);
    throw error;
  }
};

export default createEpisode;
